export default __webpack_public_path__ + "static/media/foto_09.0fe95947.jpg";